// extracted by mini-css-extract-plugin
export default {"modal":"ShowStandardMessage_modal__pgV9L","heading":"ShowStandardMessage_heading__SyPLs","success-msg":"ShowStandardMessage_success-msg__VoeyH"};